import { useSettingsStore } from '@store/index';
import { Field } from './Field';
import { Button } from '@templates/index';

export function SensitivityControls() {
  const s = useSettingsStore();

  return (
    <>
      <Field
        label="Pluck velocity"
        value={s.pluckMinVelocity.toFixed(3)}
        hint="Same threshold for both hands. Lower = triggers on softer motion. Raise if you get false plucks."
      >
        <input
          type="range"
          min={0.02}
          max={0.30}
          step={0.005}
          value={s.pluckMinVelocity}
          onChange={(e) => {
            const v = Number(e.target.value);
            // Keep per-hand fields in sync so any legacy code path
            // still reads a consistent value.
            s.setPartial({
              pluckMinVelocity: v,
              pluckMinVelocityLeft: v,
              pluckMinVelocityRight: v,
            });
          }}
        />
      </Field>

      <Field
        label="Bend deadzone"
        value={s.bendDeadzone.toFixed(3)}
        hint="Ignore small motion around the bend anchor."
      >
        <input
          type="range"
          min={0.0}
          max={0.06}
          step={0.002}
          value={s.bendDeadzone}
          onChange={(e) => s.setPartial({ bendDeadzone: Number(e.target.value) })}
        />
      </Field>

      <Field
        label="Bend range"
        value={s.bendFullRange.toFixed(2)}
        hint="How far to move for max bend."
      >
        <input
          type="range"
          min={0.05}
          max={0.3}
          step={0.01}
          value={s.bendFullRange}
          onChange={(e) => s.setPartial({ bendFullRange: Number(e.target.value) })}
        />
      </Field>

      <Field label="Max bend" value={`±${s.bendMaxCents}¢`} hint="±1200¢ = one full octave.">
        <input
          type="range"
          min={100}
          max={2400}
          step={50}
          value={s.bendMaxCents}
          onChange={(e) => s.setPartial({ bendMaxCents: Number(e.target.value) })}
        />
      </Field>

      <Field
        label="3-finger alignment"
        value={s.bendAlignThreshold.toFixed(3)}
        hint="How aligned the 3 fingers must be to enter bend. Loose = easier to trigger."
      >
        <input
          type="range"
          min={0.02}
          max={0.1}
          step={0.005}
          value={s.bendAlignThreshold}
          onChange={(e) => s.setPartial({ bendAlignThreshold: Number(e.target.value) })}
        />
      </Field>

      <Field
        label="Bend finger extension"
        value={s.bendExtendedThreshold.toFixed(2)}
        hint="Max curl for a finger to count as 'extended' in bend posture."
      >
        <input
          type="range"
          min={0.2}
          max={0.7}
          step={0.02}
          value={s.bendExtendedThreshold}
          onChange={(e) => s.setPartial({ bendExtendedThreshold: Number(e.target.value) })}
        />
      </Field>

      <Field
        label="Mode stickiness"
        value={`${s.modeStickinessMs}ms`}
        hint="Debounce for mode changes."
      >
        <input
          type="range"
          min={40}
          max={400}
          step={10}
          value={s.modeStickinessMs}
          onChange={(e) => s.setPartial({ modeStickinessMs: Number(e.target.value) })}
        />
      </Field>

      <Field label="Mirror camera">
        <input
          type="checkbox"
          checked={s.mirrorCamera}
          onChange={(e) => s.setPartial({ mirrorCamera: e.target.checked })}
        />
      </Field>

      <Field label="Show hand tracking" hint="Draws landmarks over the camera feed. Ring and pinky are dimmed.">
        <input
          type="checkbox"
          checked={s.showHandOverlay}
          onChange={(e) => s.setPartial({ showHandOverlay: e.target.checked })}
        />
      </Field>

      <Button variant="ghost" size="sm" onClick={() => s.reset()}>
        Reset sensitivity
      </Button>
    </>
  );
}
